import getTime from '../get-time';

export const getUnixTime = (date: Date | number): number => {
  return Math.floor(getTime(date) / 1000);
};

export default getUnixTime;
